module.exports = new __parcel__URL__("email-confirmed.abf16b2f.html").toString();